__webpack_require__.p = "https://staging.proposals.microsoft.com/";